const EMAIL_STATUS_PENDING = 1
const EMAIL_STATUS_REPLIED = 2
const EMAIL_STATUS_EXCLUDED = 3

const EMAIL_STATUSES = [
  {
    id: EMAIL_STATUS_REPLIED,
    name: 'Replied'
  },
  {
    id: EMAIL_STATUS_PENDING,
    name: 'No answer'
  }
]

export {
  EMAIL_STATUS_PENDING,
  EMAIL_STATUS_REPLIED,
  EMAIL_STATUS_EXCLUDED,
  EMAIL_STATUSES
}



// WEBPACK FOOTER //
// ./src/constants/emailStatus.js